import { ApiConfig } from '@/model/config.model';

export const API_CONFIG: ApiConfig = {
  DEV_API: 'https://api.clinic-workflow-v2.dev1.prenuvo.dev/api/v1',
  LOCAL_API: 'http://localhost:8002/api/v1',
  MOCK_API: '/mock-api',
  PROD_API: 'https://api.clinic-workflow.na1.prenuvo.com/api/v1',
  STAGING_API: 'https://api.clinic-workflow.stg1.prenuvo.dev/api/v1',
};
